import Flickity from 'flickity-imagesloaded';
export default class LnerExperience {
  constructor() {
    const $el = document.querySelector('.js-experience-gallery');

    if ($el) {
      this.carousel = new Flickity($el, {
        wrapAround: true,
        prevNextButtons: false,
        pageDots: true,
        adaptiveHeight: false,
      });

      window.dispatchEvent(new Event('resize'));
    }
  }
}